import labelled from "~/components/shared/labelledFormComponent";

const textFieldDefaultProps = { type: "text" };

const FormTextField = labelled("input", textFieldDefaultProps);

export default FormTextField;
